import { render, staticRenderFns } from "./member-address.vue?vue&type=template&id=753eec5c&scoped=true"
import script from "./member-address.vue?vue&type=script&lang=ts"
export * from "./member-address.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "753eec5c",
  null
  
)

export default component.exports